<script>
import ModalWrapper from "@/components/modals/ModalWrapper";
import PrimaryButton from "@/components/PrimaryButton";

export default {
  name: "PelleEffectsModal",
  components: {
    PrimaryButton,
    ModalWrapper,
  },
  computed: {
    nerfs() {
      return [
        // Numerical nerfs and disabled boostsThe Time Theorem Autobuyer
        "Всё, что открывается через улучшения Пелле не может быть открыто обычным способом",
        "Все множители ОБ и ОВ, полученные до, Обречения отключены",
        "Генерация ОБ, основанная на самой быстрой бесконечности отключена",
        "Все множители скорости Репликантов, полученные до Обречения, отключены",
        `Репликанты замедляются кардинально быстрее после ${format(Number.MAX_VALUE, 2)}`,
        "Большинство Вечных Челленджей усложнено",
        `Все Галактики только на ${formatPercents(0.5)} также эффективны`,
        `Множитель Измерений Антиматерии разделен на ${formatInt(10)}`,
        "Множитель Достижений и множество наград Достижений отключены",
        "Все множители Бесконечностей и Вечностей и их генерация отключены",
        "Чёрные дыры отключены",
        `Улучшение Реальности "Временна́я Трансцендентность" отключено`,

        // Initial QoL and automation
        "Все награды, увеличивающие ваши начальные ресурсы, кроме Достижения 21, отключены",
        "Все награды, предотвращающие ресурсы от сброса, отключены",
        "Награды Перков, уменьшающие цены разблокировки отключены, исключая группу ECR",
        "Автоматические Бесконечные и Вечные Челленджи отключены",
        "Все АвтоПокупщики Измерений и полученные до Бесконечности отключены, пока не приобретены заново через Пелле",
        "АвтоПокупщик Временны́х Теорем отключен",
        "Всё, относящееся к автоматизации Временно́го Растяжения или позднее отключено",

        // Time studies + Dilation
        "Вечное Улучшение для Измерений Времени, основанного на сыгранных днях, теперь основано на времени в текущем Армагеддоне",
        `Все множители Растянутого Времени отключены, кроме ${formatX(2)} покупаемых`,
        "Все множители Тахион Частиц отключены",
        "Все эффекты генераторов Временны́х теорем, приобретенных до Обречения отключены, за исключением улучшения Растяжения",

        // Glyphs
        "Экипировка Глифов отключена, до тех пор, пока не открыта заново",
        `Уровни Глифов снижены и редкость установлена на ${formatPercents(0)}`,
        "Эффекты от Жертвования Глифов, Alteration, и Алхимии отключены",

        // Celestial features
        "Вы не можете войти в какую-либо Реальность Божества",
        "Музыкальные Глифы не могут быть куплены",
        "Все награды Эффарига отключены",
        "Все функции, относящиеся к накоплению времени, отключены",
        "Все награды от Ви отключены",
        `Эффект ${formatInt(1)} уровня Терезы от Ра отключен`,
        "Улучшения Бесконечности не могут быть заряжены",
        "Исследования Триад и Космические Теоремы отключены",
        "Мнимые Улучшения отключены, исключая те, что относятся к ИТМ и открытиям Божеств",
        "Награды Континуума и Сингулярности отключены"
      ];
    }
  }
};
</script>

<template>
  <ModalWrapper>
    <template #header>
      Список отключенных и ослабленных эффектов в Обречении
    </template>
    <div class="pelle-effects-container">
      <p
        v-for="(nerf, idx) in nerfs"
        :key="idx"
      >
        {{ nerf }}
      </p>
    </div>
    <PrimaryButton
      class="o-primary-btn--width-medium c-modal-message__okay-btn c-modal__confirm-btn"
      @click="emitClose"
    >
      Ок
    </PrimaryButton>
  </ModalWrapper>
</template>

<style scoped>
.pelle-effects-container {
  overflow-y: scroll;
  height: 40rem;
}

p {
  margin-bottom: 1rem;
}
</style>
